const esignaturesConstants = {
    Direction: {
        Forward: 1,
        Backward: 2
    },
    SignerRoles: {
        Tenant: 'efbf09d2-68c1-4671-9623-2d473d9ae8c7',
        Cosigner: 'a3328502-3c02-4d31-917d-cca73bce1353',
        RentalOwner: '530fd732-4add-418d-a667-36d6bd0a5e65',
        StaffMember: '6477cf33-0383-4b43-b943-8ab525615b14'
    },
    HelloSignClientEvent: {
        // https://github.com/hellosign/hellosign-embedded/wiki/API-Documentation-(v2)#events
        Cancel: 'cancel',
        Close: 'close',
        CreateTemplate: 'createTemplate',
        Decline: 'decline',
        Error: 'error',
        Finish: 'finish',
        Message: 'message',
        Open: 'open',
        Ready: 'ready',
        Reassign: 'reassign',
        Send: 'send',
        Sign: 'sign'
    },
    SessionTimes: {
        TimeoutTotal: 55,
        MinuteStart: 5,
        SecondStart: 1
    },
    DocumentSignerStatus: {
        NotSent: {
            Id: 1,
            DisplayName: 'Not sent yet'
        },
        Sent: {
            Id: 2,
            DisplayName: 'Sent'
        },
        Viewed: {
            Id: 3,
            DisplayName: 'Viewed'
        },
        Signed: {
            Id: 4,
            DisplayName: 'Signed'
        },
        Error: {
            Id: 5,
            DisplayName: 'Error'
        },
        Bounced: {
            Id: 6,
            DisplayName: 'Email bounced'
        }
    },
    ReminderSentDisplayName: 'Reminder sent',
    DocumentStatus: {
        Unknown: {
            Id: 0,
            DisplayName: 'Unknown'
        },
        NotSent: {
            Id: 1,
            DisplayName: 'Not sent'
        },
        ProcessingRequest: {
            Id: 2,
            DisplayName: 'Processing request'
        },
        AwaitingSignatures: {
            Id: 3,
            DisplayName: 'Awaiting signatures'
        },
        FullySigned: {
            Id: 4,
            DisplayName: 'Fully signed'
        },
        CancellationPending: {
            Id: 5,
            DisplayName: 'Cancellation pending'
        },
        Canceled: {
            Id: 6,
            DisplayName: 'Canceled'
        },
        Failed: {
            Id: 7,
            DisplayName: 'Request failed'
        },
        SentUsingAdobe: {
            Id: 8,
            DisplayName: 'Sent using Adobe'
        },
        YourTurnToSign: {
            Id: 9,
            DisplayName: 'Awaiting your signature'
        },
        OthersTurnToSign: {
            Id: 10,
            DisplayName: 'Awaiting others\' signatures'
        },
        ProcessingSignatures: {
            Id: 11,
            DisplayName: 'Processing signatures'
        }
    },
    TemplateFileLimit: 39,
    EsignatureRequestFileLimit: 39,
    MergeFields: {
        Unknown: {
            Id: 0,
            DisplayName: 'Unknown'
        },
        RentTotal: {
            Id: 14,
            DisplayName: 'Rent total'
        },
        LeaseTerm: {
            Id: 21,
            DisplayName: 'Lease term'
        }
    },
    MergeFieldSource: {
        Buildium: 'Buildium',
        Custom: 'Custom'
    },
    ButtonStatus: {
        Enabled: 'enabled',
        Disabled: 'disabled',
        Hidden: 'hidden'
    },
    MergeFieldTypes: {
        Unknown: 0,
        Text: 1,
        Currency: 2,
        Date: 3,
        Email: 4,
        // eslint-disable-next-line id-blacklist
        Number: 5,
        Emails: 6
    },
    DocumentTypes: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        1: 'Lease',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        2: 'Addendum',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        3: 'EsignatureOtherDocument'
    },
    DocumentTypesFilters: {
        Lease: {
            Id: 1,
            DisplayName: 'Lease'
        },
        Addendum: {
            Id: 2,
            DisplayName: 'Addendum'
        },
        EsignatureOtherDocument: {
            Id: 3,
            DisplayName: 'Other document'
        }
    },
    LeaseStates: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        0: 'NotExecuted',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        1: 'Executed',
    },
    LeaseStateFilters: {
        NotExecuted: {
            Id: 0,
            DisplayName: 'Not executed'
        },
        Executed: {
            Id: 1,
            DisplayName: 'Executed'
        }
    }
};

const documentSignerStatusKeys = {};
Object.entries(esignaturesConstants.DocumentSignerStatus).forEach((entry) => {
    const key = entry[0],
        value = entry[1];
    documentSignerStatusKeys[value.Id] = key;
});

const documentStatusKeys = {};
Object.entries(esignaturesConstants.DocumentStatus).forEach((entry) => {
    const key = entry[0],
        value = entry[1];
    documentStatusKeys[value.Id] = key;
});

const documentTypesFilterKeys = {};
Object.entries(esignaturesConstants.DocumentTypesFilters).forEach((entry) => {
    const key = entry[0],
        value = entry[1];
    documentTypesFilterKeys[value.Id] = key;
});

const leaseStatesFilterKeys = {};
Object.entries(esignaturesConstants.LeaseStateFilters).forEach((entry) => {
    const key = entry[0],
        value = entry[1];
    leaseStatesFilterKeys[value.Id] = key;
});

export const DocumentSignerStatusKeys = documentSignerStatusKeys;
export const DocumentStatusKeys = documentStatusKeys; // 0: Unknown ...
export const DocumentTypesFilterKeys = documentTypesFilterKeys; // 1: Lease, 2: Addendum, 3: EsignatureOtherDocument
export const LeaseStateFilterKeys = leaseStatesFilterKeys; // 0: NotExecuted, 1: Executed

export const {
    Direction,
    SignerRoles,
    HelloSignClientEvent,
    DocumentSignerStatus,
    ReminderSentDisplayName,
    DocumentStatus,
    TemplateFileLimit,
    EsignatureRequestFileLimit,
    MergeFields,
    MergeFieldSource,
    ButtonStatus,
    SessionTimes,
    MergeFieldTypes,
    DocumentTypes,
    DocumentTypesFilters,
    LeaseStates,
    LeaseStateFilters
} = esignaturesConstants;
